import React from 'react';
import { useTranslation } from 'react-i18next';
import NeuralCanvas from '../../components/NeuralCanvas';
import CountdownTimer from '../../components/CounterDownTimer/CountdownTimer';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import useIsMobile from '../../hooks/useIsMobile';
import './Home.css';

const Home = ({ onJoinClick }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleJoinClick = () => {
    if (onJoinClick) onJoinClick();

    setTimeout(() => {
      const formElement = document.getElementById('joinForm');
      if (formElement) {
        formElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };

  return (
    <>
      <div className="overlay"></div>
      <NeuralCanvas />
      <LanguageSelector className={isMobile ? 'mobile-language-selector' : ''} />
      
      <div className={`home-container ${isMobile ? 'mobile-container' : ''}`} id="landingPage">
        <h1 id="heading" className={isMobile ? 'mobile-heading' : ''}>{t('heading')}</h1>
        <p id="description" className={isMobile ? 'mobile-description' : ''}>{t('description')}</p>
        <CountdownTimer targetDate="April 14, 2025 00:00:00" />
        <p id="home-mission" className={isMobile ? 'mobile-description' : ''}>{t('home.mission')}</p>
        <button className={`cta-button ${isMobile ? 'mobile-cta-button' : ''}`} onClick={handleJoinClick}>
          {t('join-button')}
        </button>
      </div>
    </>
  );
};

export default Home; 